import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      alignItems: 'flex-end',
      color: TextColors.dark,
      display: 'flex',
      justifyContent: 'space-between',
    },
    heading: {
      display: 'flex',
      alignItems: 'baseline',
      flexWrap: 'wrap',
      marginBottom: '-8px',
      flexGrow: 1,
    },
    query: {
      '&.MuiTypography-root': {
        '&:not(.is-empty)': {
          marginRight: '8px',
        },

        '&.is-empty': {
          width: 0,
        },
      },
    },
    totalResults: {
      '&.MuiTypography-root': {
        marginTop: '8px',
        flexShrink: 0,
        marginBottom: '8px',
        whiteSpace: 'nowrap',
      },
    },
    sortBy: {
      alignItems: 'baseline',
      color: hexToRGBA(TextColors.dark, TextOpacities.dark2),
      display: 'flex',
      flexShrink: 0,
      marginBottom: '-1px',
    },
    sortByButton: {
      '&.MuiButton-root': {
        color: TextColors.dark,
        marginLeft: muiTheme.spacing(1),
        marginRight: muiTheme.spacing(-1),
      },
    },
    menuIcon: {
      color: SecondaryColors.dark,
    },
  }),
  { name: 'GenSearchResultsHeader' },
);

export default useStyles;
